import { Component, Input, OnInit, EventEmitter, Output, OnChanges } from '@angular/core';
import { SearchLevelLabels } from '../../../../core/models/company.model';
import { ContactSearch } from '../../../../core/models/contact-search-criteria.model';
import { CommonUtilService } from '../../../../shared/services/CommonUtil.service';
import { RequestBodyService } from '../../../../shared/services/request-body.service';


@Component({
    selector: 'app-job-level',
    templateUrl: './job-level.component.html',
    styleUrls: ['./job-level.component.scss'],
    standalone: false
})
export class JobLevelComponent implements OnInit, OnChanges {
    @Input() jobLevels;
    @Input() data;
    @Input() disabled: boolean = false;
    @Output() jobLevelsSelection = new EventEmitter<boolean>();

    jobLevelkey;
    joblevelSelectAll = false;
    Labels = SearchLevelLabels;
    jobLevelData: any = [];
    constructor(public commonUtilService: CommonUtilService, private requestBody: RequestBodyService) { }
    ngOnChanges() {
        this.onChangeJobLevelKey();
        if (!this.jobLevels) {
            this.jobLevels = ContactSearch.job_levels;
            this.jobLevelData = Object.keys(ContactSearch.job_levels).map(key => ({ key: key, value: ContactSearch.job_levels[key] }));
        }
    }
    ngOnInit() {
        if (this.jobLevels) {
            this.jobLevelData = Object.keys(ContactSearch.job_levels).map(key => ({ key: key, value: ContactSearch.job_levels[key] }));
        }
    }
    onChangeJobLevel() {
        if (this.joblevelSelectAll) {
            this.jobLevelData.forEach((element) => {
                this.jobLevels[element.key] = true;
            });
        } else {
            this.jobLevelData.forEach((element) => {
                this.jobLevels[element.key] = false;
            });
        }
        this.onUniversalFilterChanged();
    }
    onChangeJobLevelKey(key?) {
        this.joblevelSelectAll = this.commonUtilService.onChangeLevelandDeratment(this.jobLevels);
        if (key || key != undefined) {
            this.onUniversalFilterChanged();
        }
    }

    onUniversalFilterChanged() {
        if(this.data){
            this.data.job_levels = this.jobLevels;
            this.requestBody.universalFilterChanged.next(this.data);
        }
        this.jobLevelsSelection.emit();
    }

}
